import { Dialog } from 'primereact/dialog';
import classes from './PortfolioOpportunities.module.scss';
import usePortfolioModalUploadAndValidation from './usePortfolioOpportunitiesModal';
import PortfolioDataValidationComponent from './components/PortfolioDataValidationComponent/PortfolioDataValidationComponent';
import UploadComponent from 'components/uploadComponent/uploadComponent';

const PortfolioOpportunitiesModal = ({
  visibility,
  toggleVisibility,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
}) => {
  const {
    fileUploaded,
    validationData,
    handleDownloadTemplate,
    handleUploadFile,
    isFileUploading,
    moleculeStrengthOptionsData,
  } = usePortfolioModalUploadAndValidation();

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={fileUploaded ? `Portfolio Opportunities` : ''}
      visible={visibility}
      style={{
        width: fileUploaded ? 'auto' : '30vw',
        maxHeight: '90vh',
        maxWidth: '80vw',
        position: 'relative',
      }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      {!fileUploaded ? (
        <UploadComponent
          toggleVisibility={toggleVisibility}
          handleDownloadTemplate={handleDownloadTemplate}
          handleUploadFile={handleUploadFile}
          isFileUploading={isFileUploading}
        />
      ) : (
        <PortfolioDataValidationComponent
          data={validationData}
          successCallBack={toggleVisibility}
          moleculeStrengthOptionsData={moleculeStrengthOptionsData}
        />
      )}
    </Dialog>
  );
};

export default PortfolioOpportunitiesModal;
